import * as React from "react";
const ArrowUp = props => <symbol viewBox="0 0 24 24" {...props}>
    <path d="M12.756 18.989V6.805l4.726 4.726a.75.75 0 001.06-1.06l-5.994-5.994a.75.75 0 00-.542-.238H12a.75.75 0 00-.53.22L5.459 10.47a.757.757 0 00-.22.53.755.755 0 00.75.75c.197 0 .391-.08.53-.22l4.737-4.737v12.195a.75.75 0 001.5 0z" />
  </symbol>;
export default ArrowUp;